<template>
  <div
    class="stat-state"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
    element-loading-text="加载中"
  >
    <search
      :formModel="formModel"
      :formButton="formButton"
      :deviceModelBusiType="3"
      :statBusiType="3"
    ></search>
    <div>
      <el-table max-height="287px" :data="tableData" border>
        <template v-for="v in tableColumn">
          <!-- <el-table-column v-if="v === 'sn'" :prop="v" :key="v" label="设备号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row[v] }}</span>
            </template>
          </el-table-column> -->
          <el-table-column :prop="v" :key="v" :label="v" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="searchState(scope)">
                {{ needTranslate(v) ? throughTime(scope.row[v]) : scope.row[v] }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-row type="flex" justify="end" style="margin-top: 8px">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="offset"
        :page-size.sync="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-row>
    <div class="stat-state-chart" :style="{ height: `${chartHeight}px`, minHeight: '500px' }">
      <v-chart :options="chartOp" :autoresize="true"></v-chart>
    </div>
    <el-dialog
      v-if="visible"
      :visible="true"
      :before-close="beforeClose"
      width="60%"
      title="设备状态查询"
    >
      <QueryState
        :sn="chooseScope.row && chooseScope.row.sn"
        :runstate="chooseScope.column && runstateDict2[chooseScope.column.label]"
        :searchTime="formModel.rangeDateVal"
        :searchVisible="false"
      />
    </el-dialog>
  </div>
</template>

<script>
import { merge } from 'lodash';

import { getDeviceState } from '@/api/stat';
import { throughTime, canvasToImg, downFile } from '@/utils/utils';
import { runstateDict2 } from '@/utils/dict';
import { statChart } from '@/echartOption/stat';
import Search from '@/components/mTable/search';

export default {
  name: 'StatState',
  components: {
    Search,
    QueryState: () => import('@/views/query/state')
  },
  data() {
    return {
      i18nPath: 'device',
      loading: false,
      busiType: 1,
      formModel: {
        officeId: [],
        taskId: [],
        sn: [],
        runstate: [],
        rangeDateVal: [new Date().getTime() - 24 * 3600 * 1000, new Date().getTime()],
        deviceModel: []
      },
      chartHeight: 300,
      chartOp: statChart(),
      tableColumn: [],
      tableData: [],
      allTableData: [],
      offset: 1,
      limit: 10,
      total: 0,
      runstateDict2,
      chooseScope: {},
      visible: false,
      formButton: [
        {
          text: '查询',
          event: this.search
        },
        {
          text: '导出',
          loading: false,
          event: this.stateExport
        }
      ]
    };
  },
  methods: {
    langChangeHandler() {
      this.search();
    },
    throughTime,
    stateExport(op) {
      op.loading = true;
      this.offset = 1;

      const { translateTo } = this.$options.filters;

      getDeviceState(
        merge(
          {
            beginTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[0],
            endTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[1],
            busiType: [this.busiType]
          },
          this.formModel
        )
      ).then(res => {
        const { dimensions, dataList } = res.data[this.busiType];
        this.tableColumn = dimensions;
        this.allTableData = dataList || [];
        this.tableData = this.allTableData.slice(0, 10);
        this.total = dataList.length;
        const series = [];
        this.chartHeight = dataList.length * 35;
        this.tableColumn.slice(3).forEach(e => {
          series.push({
            type: 'bar',
            stack: 'state',
            barMaxWidth: 20,
            encode: { x: e, seriesName: e }
          });
        });

        this.chartOp = statChart({
          series,
          dataset: {
            dimensions,
            source: dataList
          },
          grid: { bottom: '10%', top: '8%' },
          legend: {
            type: 'scroll',
            bottom: '5%',
            left: 'center',
            pageTextStyle: {
              color: '#00eeff'
            },
            textStyle: {
              color: '#00eeff'
            }
          },
          animation: false,
          xAxis: {
            name: translateTo('分钟', this.i18nPath)
          },
          yAxis: {
            name: translateTo('设备号', this.i18nPath)
          }
        });

        // 导出
        this.$nextTick().then(() => {
          canvasToImg()
            .then(imgs => {
              downFile({
                url: '/stat/exportDeviceState',
                method: 'post',
                data: merge(
                  {
                    beginTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[0],
                    endTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[1],
                    pics: imgs
                  },
                  this.formModel
                )
              });
            })
            .finally(() => {
              op.loading = false;
            });
        });
      });
    },
    needTranslate(v) {
      const { translateTo } = this.$options.filters;

      const str = translateTo('在线 离线 故障', this.i18nPath);

      return str.indexOf(v) !== -1;
    },

    search() {
      this.loading = true;
      this.offset = 1;

      const { translateTo } = this.$options.filters;

      getDeviceState(
        merge(
          {
            beginTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[0],
            endTime: this.formModel.rangeDateVal && this.formModel.rangeDateVal[1],
            busiType: [this.busiType]
          },
          this.formModel
        )
      )
        .then(res => {
          const { dimensions, dataList } = res.data[this.busiType];
          this.tableColumn = dimensions;
          this.allTableData = dataList || [];
          this.tableData = this.allTableData.slice(0, 10);
          this.total = dataList.length;
          const series = [];
          this.chartHeight = dataList.length * 35;

          const cols = this.tableColumn.slice(3);

          cols.forEach(e => {
            series.push({
              type: 'bar',
              stack: 'state',
              barMaxWidth: 20,
              encode: { x: e, seriesName: e }
            });
          });

          const list = dataList.map(e => {
            const res = cols.reduce((map, key) => {
              map[key] = Math.round(e[key] / 60);

              return map;
            }, {});

            res.sn = e.sn;

            return res;
          });

          this.chartOp = statChart({
            series,
            dataset: {
              dimensions,
              source: list
            },
            grid: { bottom: '10%', top: '8%' },
            legend: {
              type: 'scroll',
              bottom: '5%',
              left: 'center',
              pageTextStyle: {
                color: '#00eeff'
              },
              textStyle: {
                color: '#00eeff'
              }
            },
            animation: false,
            xAxis: {
              name: translateTo('分钟', this.i18nPath)
            },
            yAxis: {
              name: translateTo('设备号', this.i18nPath)
            }
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      this.offset = val;
      this.tableData = this.allTableData.slice(
        (this.offset - 1) * this.limit,
        this.limit * this.offset
      );
    },
    searchState(scope) {
      this.chooseScope = scope;
      this.visible = true;
    },
    beforeClose() {
      this.visible = false;
    }
  },
  created() {
    this.search();
  }
};
</script>

<style lang="scss">
.stat-state {
  box-sizing: border-box;
  height: 100%;
  .stat-state-chart {
    // calc(100% - 400px)
    // height: 1000px;
    background-color: $bg-color;
    overflow: hidden;
    margin-top: 10px;
  }
}
</style>
